module.exports = __webpack_public_path__ + "img/item3.95f68100.png";